namespace $ {
	export class $visavis_cube extends $mol_book2 {
		
		/**
		 * ```tree
		 * plot $visavis_plot
		 * ```
		 */
		@ $mol_mem
		plot() {
			const obj = new this.$.$visavis_plot()
			
			return obj
		}
		
		/**
		 * ```tree
		 * heatmap? false
		 * ```
		 */
		@ $mol_mem
		heatmap(next?: any) {
			if ( next !== undefined ) return next as never
			return false
		}
		
		/**
		 * ```tree
		 * order* /number
		 * ```
		 */
		order(id: any) {
			return [
			] as readonly number[]
		}
		
		/**
		 * ```tree
		 * order_current? \nump
		 * ```
		 */
		@ $mol_mem
		order_current(next?: any) {
			if ( next !== undefined ) return next as never
			return "nump"
		}
		
		/**
		 * ```tree
		 * x_op false
		 * ```
		 */
		x_op() {
			return false
		}
		
		/**
		 * ```tree
		 * y_op false
		 * ```
		 */
		y_op() {
			return false
		}
		
		/**
		 * ```tree
		 * z_op false
		 * ```
		 */
		z_op() {
			return false
		}
		
		/**
		 * ```tree
		 * x_sort? \nump
		 * ```
		 */
		@ $mol_mem
		x_sort(next?: any) {
			if ( next !== undefined ) return next as never
			return "nump"
		}
		
		/**
		 * ```tree
		 * y_sort? \nump
		 * ```
		 */
		@ $mol_mem
		y_sort(next?: any) {
			if ( next !== undefined ) return next as never
			return "nump"
		}
		
		/**
		 * ```tree
		 * z_sort? \nump
		 * ```
		 */
		@ $mol_mem
		z_sort(next?: any) {
			if ( next !== undefined ) return next as never
			return "nump"
		}
		
		/**
		 * ```tree
		 * colorset /
		 * 	\#3e3f95
		 * 	\#c00
		 * 	\#FE9A2E
		 * 	\#090
		 * 	\#f0f
		 * 	\#09f
		 * 	\#666
		 * 	\#0f3
		 * 	\#0ff
		 * 	\#90c
		 * ```
		 */
		colorset() {
			return [
				"#3e3f95",
				"#c00",
				"#FE9A2E",
				"#090",
				"#f0f",
				"#09f",
				"#666",
				"#0f3",
				"#0ff",
				"#90c"
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * heatmap_colors /
		 * 	\rgb(150,0,90)
		 * 	\rgb(0,0,200)
		 * 	\rgb(0,25,255)
		 * 	\rgb(0,152,255)
		 * 	\rgb(44,255,150)
		 * 	\rgb(151,255,0)
		 * 	\rgb(255,234,0)
		 * 	\rgb(255,111,0)
		 * 	\rgb(255,0,0)
		 * ```
		 */
		heatmap_colors() {
			return [
				"rgb(150,0,90)",
				"rgb(0,0,200)",
				"rgb(0,25,255)",
				"rgb(0,152,255)",
				"rgb(44,255,150)",
				"rgb(151,255,0)",
				"rgb(255,234,0)",
				"rgb(255,111,0)",
				"rgb(255,0,0)"
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * pages /
		 * 	<= Plot
		 * 	<= Setup
		 * ```
		 */
		pages() {
			return [
				this.Plot(),
				this.Setup()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * plot_title \
		 * ```
		 */
		plot_title() {
			return ""
		}
		
		/**
		 * ```tree
		 * Root $mol_view
		 * ```
		 */
		@ $mol_mem
		Root() {
			const obj = new this.$.$mol_view()
			
			return obj
		}
		
		/**
		 * ```tree
		 * value_min 0
		 * ```
		 */
		value_min() {
			return 0
		}
		
		/**
		 * ```tree
		 * Heatmap_min $mol_view sub / <= value_min
		 * ```
		 */
		@ $mol_mem
		Heatmap_min() {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => [
				this.value_min()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * heatmap_color* \
		 * ```
		 */
		heatmap_color(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * Heatmap_color*0 $mol_view style * background <= heatmap_color*
		 * ```
		 */
		@ $mol_mem_key
		Heatmap_color(id: any) {
			const obj = new this.$.$mol_view()
			
			obj.style = () => ({
				background: this.heatmap_color(id)
			} as Record< string, any >)
			
			return obj
		}
		
		/**
		 * ```tree
		 * value_max 0
		 * ```
		 */
		value_max() {
			return 0
		}
		
		/**
		 * ```tree
		 * Heatmap_max $mol_view sub / <= value_max
		 * ```
		 */
		@ $mol_mem
		Heatmap_max() {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => [
				this.value_max()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * heatmap_color_list /
		 * 	<= Heatmap_min
		 * 	<= Heatmap_color*0
		 * 	<= Heatmap_max
		 * ```
		 */
		heatmap_color_list() {
			return [
				this.Heatmap_min(),
				this.Heatmap_color("0"),
				this.Heatmap_max()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Heatmap_legend $mol_list rows <= heatmap_color_list
		 * ```
		 */
		@ $mol_mem
		Heatmap_legend() {
			const obj = new this.$.$mol_list()
			
			obj.rows = () => this.heatmap_color_list()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Side_right $mol_scroll sub / <= Heatmap_legend
		 * ```
		 */
		@ $mol_mem
		Side_right() {
			const obj = new this.$.$mol_scroll()
			
			obj.sub = () => [
				this.Heatmap_legend()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * plot_body /
		 * 	<= Root
		 * 	<= Side_right
		 * ```
		 */
		plot_body() {
			return [
				this.Root(),
				this.Side_right()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * draw null
		 * ```
		 */
		draw() {
			return null as any
		}
		
		/**
		 * ```tree
		 * Plot $mol_page
		 * 	title <= plot_title
		 * 	body <= plot_body
		 * 	auto <= draw
		 * ```
		 */
		@ $mol_mem
		Plot() {
			const obj = new this.$.$mol_page()
			
			obj.title = () => this.plot_title()
			obj.body = () => this.plot_body()
			obj.auto = () => this.draw()
			
			return obj
		}
		
		/**
		 * ```tree
		 * nonformers? false
		 * ```
		 */
		@ $mol_mem
		nonformers(next?: any) {
			if ( next !== undefined ) return next as never
			return false
		}
		
		/**
		 * ```tree
		 * Nonformers $mol_check_box
		 * 	hint @ \Continuous solid solutions and complete insolubility systems
		 * 	title @ \Show
		 * 	checked? <=> nonformers?
		 * ```
		 */
		@ $mol_mem
		Nonformers() {
			const obj = new this.$.$mol_check_box()
			
			obj.hint = () => this.$.$mol_locale.text( '$visavis_cube_Nonformers_hint' )
			obj.title = () => this.$.$mol_locale.text( '$visavis_cube_Nonformers_title' )
			obj.checked = (next?: any) => this.nonformers(next)
			
			return obj
		}
		
		/**
		 * ```tree
		 * Nonformers_label $mol_labeler
		 * 	title @ \Non-formers
		 * 	Content <= Nonformers
		 * ```
		 */
		@ $mol_mem
		Nonformers_label() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$visavis_cube_Nonformers_label_title' )
			obj.Content = () => this.Nonformers()
			
			return obj
		}
		
		/**
		 * ```tree
		 * order_dict *
		 * 	nump @ \Periodic number
		 * 	num @ \Atomic number
		 * 	size @ \Atomic size
		 * 	rea @ \Atomic reactivity
		 * 	rpp @ \Pseudopotential radii
		 * 	rion @ \Ionic radii
		 * 	rcov @ \Covalent radii
		 * 	rmet @ \Metallic radii
		 * 	tmelt @ \Melting temperature
		 * 	eneg @ \Electronegativity
		 * ```
		 */
		order_dict() {
			return {
				nump: this.$.$mol_locale.text( '$visavis_cube_order_dict_nump' ),
				num: this.$.$mol_locale.text( '$visavis_cube_order_dict_num' ),
				size: this.$.$mol_locale.text( '$visavis_cube_order_dict_size' ),
				rea: this.$.$mol_locale.text( '$visavis_cube_order_dict_rea' ),
				rpp: this.$.$mol_locale.text( '$visavis_cube_order_dict_rpp' ),
				rion: this.$.$mol_locale.text( '$visavis_cube_order_dict_rion' ),
				rcov: this.$.$mol_locale.text( '$visavis_cube_order_dict_rcov' ),
				rmet: this.$.$mol_locale.text( '$visavis_cube_order_dict_rmet' ),
				tmelt: this.$.$mol_locale.text( '$visavis_cube_order_dict_tmelt' ),
				eneg: this.$.$mol_locale.text( '$visavis_cube_order_dict_eneg' )
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * X_order_select $mol_select
		 * 	value? <=> x_sort?
		 * 	dictionary <= order_dict
		 * ```
		 */
		@ $mol_mem
		X_order_select() {
			const obj = new this.$.$mol_select()
			
			obj.value = (next?: any) => this.x_sort(next)
			obj.dictionary = () => this.order_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * X_order_label $mol_labeler
		 * 	title @ \X sort by
		 * 	Content <= X_order_select
		 * ```
		 */
		@ $mol_mem
		X_order_label() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$visavis_cube_X_order_label_title' )
			obj.Content = () => this.X_order_select()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Y_order_select $mol_select
		 * 	value? <=> y_sort?
		 * 	dictionary <= order_dict
		 * ```
		 */
		@ $mol_mem
		Y_order_select() {
			const obj = new this.$.$mol_select()
			
			obj.value = (next?: any) => this.y_sort(next)
			obj.dictionary = () => this.order_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Y_order_label $mol_labeler
		 * 	title @ \Y sort by
		 * 	Content <= Y_order_select
		 * ```
		 */
		@ $mol_mem
		Y_order_label() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$visavis_cube_Y_order_label_title' )
			obj.Content = () => this.Y_order_select()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Z_order_select $mol_select
		 * 	value? <=> z_sort?
		 * 	dictionary <= order_dict
		 * ```
		 */
		@ $mol_mem
		Z_order_select() {
			const obj = new this.$.$mol_select()
			
			obj.value = (next?: any) => this.z_sort(next)
			obj.dictionary = () => this.order_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Z_order_label $mol_labeler
		 * 	title @ \Z sort by
		 * 	Content <= Z_order_select
		 * ```
		 */
		@ $mol_mem
		Z_order_label() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => this.$.$mol_locale.text( '$visavis_cube_Z_order_label_title' )
			obj.Content = () => this.Z_order_select()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Setup $mol_page
		 * 	title @ \Setup
		 * 	body /
		 * 		<= Nonformers_label
		 * 		<= X_order_label
		 * 		<= Y_order_label
		 * 		<= Z_order_label
		 * ```
		 */
		@ $mol_mem
		Setup() {
			const obj = new this.$.$mol_page()
			
			obj.title = () => this.$.$mol_locale.text( '$visavis_cube_Setup_title' )
			obj.body = () => [
				this.Nonformers_label(),
				this.X_order_label(),
				this.Y_order_label(),
				this.Z_order_label()
			] as readonly any[]
			
			return obj
		}
	}
	
}

